/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var Icon2fa = createReactComponent("2fa", "Icon2fa", [
  ["path", { d: "M7 16h-4l3.47 -4.66a2 2 0 1 0 -3.47 -1.54", key: "svg-0" }],
  ["path", { d: "M10 16v-8h4", key: "svg-1" }],
  ["path", { d: "M10 12l3 0", key: "svg-2" }],
  ["path", { d: "M17 16v-6a2 2 0 0 1 4 0v6", key: "svg-3" }],
  ["path", { d: "M17 13l4 0", key: "svg-4" }]
]);

export { Icon2fa as default };
//# sourceMappingURL=Icon2fa.js.map
